import { render, staticRenderFns } from "./procurementDetail.vue?vue&type=template&id=5e9909fa&scoped=true"
import script from "./procurementDetail.vue?vue&type=script&lang=js"
export * from "./procurementDetail.vue?vue&type=script&lang=js"
import style0 from "./procurementDetail.vue?vue&type=style&index=0&id=5e9909fa&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e9909fa",
  null
  
)

export default component.exports